import { render, staticRenderFns } from "./relatorioSessao.vue?vue&type=template&id=b58e8ad6&scoped=true"
import script from "./relatorioSessao.vue?vue&type=script&lang=js"
export * from "./relatorioSessao.vue?vue&type=script&lang=js"
import style0 from "./relatorioSessao.vue?vue&type=style&index=0&id=b58e8ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58e8ad6",
  null
  
)

export default component.exports